export const deleteSimpleArr = (arr: any[], item: any) => {
  const existIdx = arr.findIndex((p) => p === item);
  if (existIdx !== -1) {
    arr.splice(existIdx, 1);
  }
  return arr;
};

export const deleteArr = (arr: any[], item: any, key = "id") => {
    const existIdx = arr.findIndex((p) => p[key] === item[key]);
    if (existIdx !== -1) {
        arr.splice(existIdx, 1);
    }
    return arr;
};
export const addOrReplaceArr = (arr: any[], item: any, key = "id") => {
    const existIdx = arr.findIndex((p) => p[key] === item[key]);
    if (existIdx === -1) {
        arr.push(item);
    } else {
        arr[existIdx] = item;
    }
    return arr;
};

export const formatPhoneNumber = (value: string) => {
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.toString().replace(/[^\d]/g, '');

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early

    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
    )}-${phoneNumber.slice(6, 10)}`;
}


export const deformatPhoneNumber = (value: string) => {
    if (!value) return value;
    // ( ) -
    return value.toString().replace(/\)/g, '').replace(/\(/g, '').replace(/-/g, '').replace(/ /g, '')
}

